import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';

import { NextPanel } from 'src/app/models/next-panel';
import { BenefitSummaryList, CancelBenefit } from 'src/app/models/benefit-summary';
import { AutoTermResponse } from 'src/app/models/core-benefit';
import { EnrollmentBenefitCategory, EnrollmentBenefitTerm } from '../models/enrollment-category';
import { BenefitSelection, BenefitSelectionPayload } from '../models/benefit';

const controllerRoute = '/term-benefit';

@Injectable()
export class EnrollmentTermService {

    constructor(
        private apiService: ApiService,
    ) {
    }

    public initializeSerivce(payload: EnrollmentBenefitTerm): Observable<NextPanel> {
        return this.apiService.post(`${controllerRoute}/initialize`, payload).pipe(
            map((response: NextPanel) => {
                return response;
            }),
        );
    }

    public getBenefits(): Observable<BenefitSelection> {
        return this.apiService.get(`${controllerRoute}/benefits-to-term`).pipe(
            map((response: BenefitSelection) => {
                return response;
            }),
        );
    }

    public setBenefits(payload: BenefitSelectionPayload): Observable<NextPanel> {
        return this.apiService.post(`${controllerRoute}/benefits-to-term`, payload).pipe(
            map((response: NextPanel) => {
                return response;
            }),
        );
    }

    public getAutoTermPanel(): Observable<AutoTermResponse> {
        return this.apiService.get(`${controllerRoute}/auto-term`).pipe(
            map((response: AutoTermResponse) => {
                return response;
            }),
        );
    }

    public submitAutoTermPanel(): Observable<NextPanel> {
        return this.apiService.post(`${controllerRoute}/auto-term`, null).pipe(
            map((response: NextPanel) => {
                return response;
            }),
        );
    }

    public getRequestTerm(): Observable<CancelBenefit> {
        return this.apiService.get(`${controllerRoute}/request-term`).pipe(
            map((response: CancelBenefit) => {
                return response;
            }),
        );
    }

    public submitRequestTerm(): Observable<NextPanel> {
        return this.apiService.post(`${controllerRoute}/request-term`, null).pipe(
            map((response: NextPanel) => {
                return response;
            }),
        );
    }

    public getSummaryPanel(): Observable<BenefitSummaryList> {
        return this.apiService.get(`${controllerRoute}/summary`).pipe(
            map((response: BenefitSummaryList) => {
                return response;
            }),
        );
    }

    public submitSummaryPanel(): Observable<NextPanel> {
        return this.apiService.post(`${controllerRoute}/summary`, null).pipe(
            map((response: NextPanel) => {
                return response;
            }),
        );
    }

    public getFinalizePanel(): Observable<EnrollmentBenefitCategory> {
        return this.apiService.get(`${controllerRoute}/complete`).pipe(
            map((response: EnrollmentBenefitCategory) => {
                return response;
            }),
        );
    }
}